// export const navServiceMenu=[
//     {
//         name:"E-Commerce",
//         link:"/services?serviceTitle=custom"
//     },
//     {
//         name:"Web Apps",
//         link:"/services?serviceTitle=application"
//     },
//     {
//         name:"Mobile Apps",
//         link:"/mobile"
//     },
//     {
//         name:"Cloud",
//         link:"/cloud"
//     },
//     {
//         name:"IOT",
//         link:"/iot"
//     },
//     {
//         name:"IT Security",
//         link:"/it-security"
//     },
//     {
//         name:"Other Services",
//         link:"/other"
//     },
// ]
export const navServiceMenu=[
    {
        name:"Custom Solutions",
        link:"/services?serviceTitle=custom",
        id:"custom",
    },
    // {
    //     name:"Applications",
    //     link:"/services?serviceTitle=application",
    //     id:"application",
    // },
    {
        name:"Oracle Cloud",
        link:"/services?serviceTitle=oracle",
        id:"oracle",
    },
    {
        name:"Sharepoint Cloud",
        link:"/services?serviceTitle=sharepoint",
        id:"sharepoint",
    },
    {
        name:"Saleforce Cloud",
        link:"/services?serviceTitle=saleforce",
        id:"saleforce",
    },
    {
        name:"Cybersecurity Services",
        link:"/services?serviceTitle=cyber",
        id:"cyber",
    },
    {
        name:"Test Automation",
        link:"/services?serviceTitle=testautomation",
        id:"testautomation",
    },
    // {
    //     name:"Cloud Solutions",
    //     link:"/services?serviceTitle=cloud",
    //     id:"cloud",
    // },
    // {
    //     name:"Saas Solutions",
    //     link:"/services?serviceTitle=saas",
    //     id:"saas",
    // },
    
]

export const navProductMenu=[
    {
        name:"Enterprise Asset Management",
        link:"/products/eam",
        
    },
    {
        name:"Internet Booking Platform",
        link:"/products/ipb",
    },
    {
        name:"Permit To Work (PTW)",
        link:"/products/ptw"
    },
    {
        name:"Safety Walk",
        link:"/products/safetywalk"
    },
    {
        name:"Secuity e-Form",
        link:"/products/e_form"
    },
    {
        name:"Online Job Training",
        link:"/products/ojt"
    },
   

]